document.addEventListener("DOMContentLoaded", function () {
    documentReady();
});

function documentReady() {

    if (typeof jQuery === 'undefined') {
        console.log("jquery is missing");
        return;
    }
    //InIt
    setupHelp();
    editorsSetup();
    dateControlSetup();

    //Events
    if (typeof jQuery.colorbox !== 'undefined') {
        $('.ViewImage').colorbox({ onComplete: function () { $.colorbox.resize(); $('#cboxClose').remove(); } });
        $("#CookieControlCentre,.CookieControlCentreFooter").colorbox({ iframe: true, scrolling: true, width: "80%", height: "80%", closeButton: false, overlayClose: false, escKey: false });
        //openCookieControlCentre();
    }
}

//Init Functions
var isChrome = !!window.chrome; 
